import { graphql } from '../../graphql';

export const bulkPaymentMutation = graphql(`
  mutation CreateBulkPayment(
    $paidServiceOptionId: ID!
    $paymentMethodId: ID!
    $targetIds: [ID!]!
    $paidServiceId: ID!
  ) {
    createPayment(
      input: {
        paidServiceOptionId: $paidServiceOptionId
        paymentMethodId: $paymentMethodId
        targetId: $targetIds
        paidServiceId: $paidServiceId
      }
    ) {
      status
    }
  }
`);
